<template>
  <div class="row mt-2">
    <b-form @submit.prevent="save">
      <b-form-group label="Start title:">
        <b-form-input
          type="text"
          v-model.trim="$v.startTitle.$model"
          :class="{ 'is-invalid': $v.startTitle.$error }"
          autocomplete="off"
          :disabled="inPorcess"
        />
        <b-form-invalid-feedback v-if="!$v.startTitle.required">Display Name is required</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Workflow:">
        <b-form-select
          v-model="$v.workflow.$model"
          :class="{ 'is-invalid': $v.workflow.$error }"
          :options="availableWorkflows"
          :disabled="inPorcess"
        />
        <b-form-invalid-feedback v-if="!$v.workflow.required">Table to lookup is required</b-form-invalid-feedback>
      </b-form-group>
      <b-button variant="success" type="submit">Save</b-button>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
// services
import db from '@/services/db'

export default {
  name: "WorkflowConfigComponent",
  props: {
    control: {
      type: Object
    }
  },
  data() {
    return {
      inPorcess: false,
      displayName: null,
      workflow: null,
      startTitle: null,
      type: 'workflow',
      order: null
    }
  },
  computed: {
    ...mapState(['dataGrid_options', 'workflows']),
    availableWorkflows() {
      const workflows = []

      for (let item in this.workflows) {
        workflows.push({
          text: this.workflows[item].name,
          value: item,
        })
      }

      return workflows
    },
  },
  methods: {
    async save() {
      if (this.inPorcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inPorcess = true

      const newWorkflowMeta = {
        type: this.type,
        displayName: this.displayName,
        order: this.order,
        workflow: this.workflow,
        startTitle: this.startTitle
      }

      let baseGridMeta = JSON.parse(JSON.stringify(this.dataGrid_options[this.control.gridId].meta))
      baseGridMeta[this.control.propName] = newWorkflowMeta

      await db.dataGrid.data.setNewMeta(this.control.gridId, baseGridMeta)

      this.inPorcess = false

      this.$nextTick(() => {
        this.$v.$reset()
      })
    }
  },
  mounted(){
    let workflow = this.dataGrid_options[this.control.gridId].meta[this.control.propName]
    this.displayName = workflow.displayName
    this.startTitle = workflow.startTitle
    this.workflow = workflow.workflow
    this.order = workflow.order
  },
  validations: {
    startTitle: {
      required
    },
    workflow: {
      required,
    },
  },
}
</script>

<style scoped>

</style>
